import { useState, useEffect, useRef } from "react";
import {
  Button,
  MenuButton,
  Menu,
  MenuList,
  MenuItem,
  Avatar,
  CircularProgress,
  Flex
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { getAccount } from "utils/sessionHelper";
import async from 'async';

export const ProfileSelector = ({
        session,
        onSelectedCallBack = (selection: any = undefined, e: any=undefined) => {},
    }
) => {
    const account = getAccount(session);
    const initDropDownValues = (account?.subscription?.isInOrg && account?.subscription?.org)
    ? [{
        mode: "organization",
        account,
    }
    ]
    : [];
    initDropDownValues.push({
        mode: "personal",
        account,
    });

    const [selectText, setSelectText] = useState<string>(account?.name);
    const [avatarImage, setAvatarImage] = useState<string>(account?.image);
    const [avatarText, setAvatarText] = useState<string>("");
    const [accountsInOrg, setAccountsInOrg] = useState<any>(session?.user?.linkAccounts);
    const [profileSelection, setProfileSelection] = useState(initDropDownValues);
    const [dropdownLoaded, setDropdownLoaded] = useState<boolean>(false);
    let orgProfileName = useRef(account?.name);

    // console.log(profileSelection);

    useEffect(() => {
        if(accountsInOrg && accountsInOrg.length > 0){
            let newProfileSelection: any = [];

            const formatProfile = async () => {
                accountsInOrg?.forEach((acc) => {
                    newProfileSelection.push({
                        mode: "personal",
                        account: acc,
                    });
                });
            }

            const findOrgName = async (newProfileSelection) =>{
                await async.detect(newProfileSelection, (member, callback) => {
                    if(member?.account?.id == account?.subscription?.org) {
                        orgProfileName.current = member?.account?.name;
                        callback(null, true);
                    }
                    else callback();
                });
            }

            formatProfile();
            findOrgName(newProfileSelection);
            
            const newProfileIds = new Set(newProfileSelection.map(p => p?.account?.id));
            const uniqueInitDropdownValues = initDropDownValues?.filter((profile)=>{
              return !(newProfileIds?.has(profile?.account?.id) && profile?.mode !== "organization");
            });
            
            newProfileSelection = [...uniqueInitDropdownValues, ...newProfileSelection];
            // console.log('newProfileSelection:', newProfileSelection);
            setProfileSelection(newProfileSelection);
            setDropdownLoaded(true);
        } else {
            setDropdownLoaded(true);
        }
        
    },[accountsInOrg])

    const handleOnSelect = async (selected, event) => {
        setSelectText(
            (selected?.mode == "organization")
            ? "Organization Stats"
            : selected?.account?.name
        );

        setAvatarImage(
            (selected?.mode == "organization")
            ? ""
            : selected?.account?.image
        );

        const newAvatarText = (selected?.mode == "organization")
                               ? orgProfileName.current
                               : selected?.account?.name;

        //remove emoji, etc. from avatar text/name...
        setAvatarText(newAvatarText
            .replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu,"")
            .replace(/\s+/g, ' ')
            .trim()
        );

        onSelectedCallBack(selected, event);
    }
    
    return (
      <Flex
        // pt="10"
      >
        {
          //@ts-ignore
          <>
            <Avatar
              w="36px"
              mr="6px"
              h="36px"
              name={avatarText}
              src={avatarImage}
            />
            <Menu variant="secondary" >
              <MenuButton
                as={Button}
                // size="sm"
                variant="secondary"
                rightIcon={<ChevronDownIcon />}
                // border='0'
                // h="36px"
                // fontWeight="medium"
                // pl="1"
                // pr="1"
              >
                {selectText}
              </MenuButton>
              <MenuList
                overflowY="auto"
                maxH="400px"
              >
                <MenuItem
                  key={profileSelection?.[0]?.account?.name}
                  onClick={() => {
                    window.location.href = "/settings?tab=team";
                  }}
                //   textColor="gray.500"
                >
                  + Add Team Member(s)
                </MenuItem>
                {!dropdownLoaded && (
                  <MenuItem key="loader" onClick={() => {}}>
                    <CircularProgress
                      isIndeterminate
                      size="15px"
                      w="100%"
                      display="flex"
                      justifyContent="center"
                      color="gray.500"
                    />
                  </MenuItem>
                )}
                {dropdownLoaded &&
                  //@ts-ignore
                  profileSelection.map((selected) => (
                    <MenuItem
                      key={selected?.account?.name + "-" + selected?.mode}
                      onClick={(e) => {
                        handleOnSelect(selected, e);
                      }}
                    >
                      {selected?.mode == "organization"
                        ? "Organization Stats"
                        : selected?.account?.name}
                    </MenuItem>
                ))}
              </MenuList>
            </Menu>
          </>
        }
      </Flex>
    );
}